(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;

  // Respect the visitor's explicit reduced-motion preference only.
  //
  // NOTE: this condition previously also included lowPower, lowMemory and lowCpu.
  // Those tests were far too broad: hardwareConcurrency <= 2 matches many ordinary
  // phones, and privacy-hardened browsers (Brave, Firefox with resistFingerprinting)
  // deliberately report exactly 2 cores. Any matching visitor had every animation and
  // transition on the site cut to 0.001ms, and background videos skipped entirely by
  // the isBackgroundVideo && theme.performanceLite guard in theme.js.
  // The detection vars are kept below so the behaviour can be re-enabled deliberately.
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var lowPower = !!(connection && connection.saveData);
  var lowMemory = typeof navigator.deviceMemory === 'number' && navigator.deviceMemory <= 2;
  var lowCpu = typeof navigator.hardwareConcurrency === 'number' && navigator.hardwareConcurrency <= 2;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion) {
    root.classList.add('performance-lite');
  }

  function idle(fn, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(fn, { timeout: timeout || 2500 });
    } else {
      window.setTimeout(fn, 1200);
    }
  }

  function afterLoad(fn) {
    if (doc.readyState === 'complete') {
      idle(fn, 2500);
    } else {
      window.addEventListener('load', function () {
        idle(fn, 2500);
      }, { once: true, passive: true });
    }
  }

  function loadScript(src, onload) {
    var script = doc.createElement('script');
    script.src = src;
    script.async = true;
    if (onload) script.onload = onload;
    doc.head.appendChild(script);
  }

  // Delay non-critical Google Ads/gtag network work until after the first render.
  afterLoad(function () {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', 'AW-17424250466');
    loadScript('https://www.googletagmanager.com/gtag/js?id=AW-17424250466');
  });

  // Trustpilot sits in the footer. Do not download its script until the
  // widget is close to the viewport. This avoids a third-party request on
  // visits where the user never reaches the footer.
  function loadTrustpilot() {
    loadScript('//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', function () {
      if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
        doc.querySelectorAll('.trustpilot-widget').forEach(function (element) {
          try {
            window.Trustpilot.loadFromElement(element, true);
          } catch (e) {}
        });
      }
    });
  }

  function watchTrustpilot() {
    var widgets = doc.querySelectorAll('.trustpilot-widget');
    if (!widgets.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            observer.disconnect();
            loadTrustpilot();
            break;
          }
        }
      }, { rootMargin: '400px 0px' });

      widgets.forEach(function (widget) { observer.observe(widget); });
    } else {
      afterLoad(loadTrustpilot);
    }
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', watchTrustpilot, { once: true });
  } else {
    watchTrustpilot();
  }
})();
